import { render, staticRenderFns } from "./AddSecondProject-View.vue?vue&type=template&id=118a08ea&scoped=true&"
import script from "./AddSecondProject-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddSecondProject-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddSecondProject-View.vue?vue&type=style&index=0&id=118a08ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a08ea",
  null
  
)

export default component.exports